import { useTranslation } from "./useTranslation";
export function useIsBrazil() {
  var _useTranslation = useTranslation(),
    countryCode = _useTranslation.countryCode;
  return countryCode === 'br';
}